
import { onDocumentReady, Carousel } from "@story/story_assets";

onDocumentReady(function() {
	// for (let element of document.querySelectorAll(".slider")) {
	// 	new Slider(element);
	// }
	for (let element of document.querySelectorAll(".carousel")) {
		new Carousel(element);
	}
});